import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { customersActions } from "./customers.actions";
import { exhaustMap, map } from "rxjs";
import { Customer, CustomerFilters } from "../../models/customer.model";
import { environment } from "../../../environments/environment";

@Injectable()
export class CustomersEffects {
    private httpClient = inject(HttpClient);
    private actions$ = inject(Actions);

    get$ = createEffect(() =>
        this.actions$.pipe(
            ofType(customersActions.loadCustomers),
            exhaustMap(({data}) => {
                let params = new HttpParams();

                if(data) {
                    const filters = data as CustomerFilters;

                    Object.entries(filters).forEach(([key, value]) => {
                        if(value != null) {
                            if(typeof value === "string") {
                                if(value != "") {
                                    params = params.set(key, value);
                                }
                            }
                            else {
                                params = params.set(key, value);
                            }
                        }
                    })
                }

                const req = this.httpClient.get<Customer[]>(`${environment.api}/customer/all`, {params});

                return req.pipe(
                    map((payload) => customersActions.loadCustomersSuccess({payload}))
                )
            })
        )
    )

    assign$ = createEffect(() =>
        this.actions$.pipe(
            ofType(customersActions.assignAgent),
            exhaustMap(({data}) => {
                const req = this.httpClient.put(`${environment.api}/customer/change_user`, data);

                return req.pipe(
                    map((_) => customersActions.loadCustomers({data: null}))
                )
            })
        )
    )
}